import { LegalPage } from "@/pages/LegalPage";

const H = ({ children }) => (
  <h2 className="font-display text-2xl font-bold uppercase tracking-wide text-white">{children}</h2>
);

const PrivacyPolicy = () => (
  <LegalPage
    title="Privacy Policy"
    description="Privacy policy for Freedom Mobile Auto Detailing — how we handle your name, phone, email, vehicle, and service location information from quote requests in Gap, PA."
    path="/privacy-policy"
    updated="July 2026"
    testId="privacy-policy-page"
  >
    <section>
      <H>What We Collect</H>
      <p className="mt-3">
        When you submit the quote form on this website, we collect the information you provide, including:
      </p>
      <ul className="mt-3 list-disc space-y-1.5 pl-6 text-slate-400">
        <li>Name</li>
        <li>Phone number</li>
        <li>Email address</li>
        <li>Vehicle information (year, make, model, type, and condition)</li>
        <li>Service location</li>
        <li>Messages submitted through the website</li>
      </ul>
    </section>
    <section>
      <H>How We Use It</H>
      <p className="mt-3">
        The information you submit is used only to respond to quote requests, scheduling inquiries, and customer
        communication. That's it. We don't add you to marketing lists, and we don't use your details for anything
        beyond getting your vehicle detailed.
      </p>
    </section>
    <section>
      <H>What We Don't Do</H>
      <p className="mt-3">
        We do not sell, rent, or share your personal information with third parties for their marketing purposes.
        Your information stays with Freedom Mobile Auto Detailing.
      </p>
    </section>
    <section>
      <H>How It's Handled</H>
      <p className="mt-3">
        Quote form submissions are delivered to our business email so we can follow up with you. Reasonable
        technical measures are in place to keep this website and its form secure. If you'd like any information
        you've submitted to be corrected or deleted, just contact us and we'll take care of it.
      </p>
    </section>
  </LegalPage>
);

export default PrivacyPolicy;
